import Auth from './Auth.js';
import UserAgent from './UserAgent.js';
import { InvalidValueException, MissingParameterException, UnauthorizedException } from './exceptions.js';
import { isTokenValid, mic } from "./utils.js";

class Softphone{
    #isLoggedIn;
    #authObj;
    #userAgent; 

    constructor(){
        this.#userAgent = null;
        this.#isLoggedIn = false;
        this.#authObj = null;
    }

    async login({type, token, email}){
        if(!type || !token || !email){
            throw new MissingParameterException('Softphone.login', ['type', 'token', 'email'])
        }
        const authObj = new Auth({type, token, email});
        this.#authObj = authObj;
        if(type === 'JWT'){
            const res = await this.#authObj.registerSoftphone();
            if(res === true){
                this.#isLoggedIn = true;
                this.#authObj.isLoggedIn = true;
            }
            return res;
        }
        else if(type === 'OAuth2.0'){
            await this.#authObj.obtainSecretKey();
            const res = await this.#authObj.registerSoftphone();
            if(res === true){
                this.#isLoggedIn = true;
                this.#authObj.isLoggedIn = true;
            }
            return res;
        }
        else{
            throw new InvalidValueException('Softphone.login', 'type', type, ['JWT', 'OAuth2.0'])
        }
    }

    start(listeners, audioElements, logLevel = 'debug'){
        this.#checkIsLoggedIn('Softphone.start');
        if(!audioElements || !audioElements.remote){
            throw new MissingParameterException('Softphone.start', ['audioElements', 'audioElements.remote'])
        }
        const config = {
            audioElements,
            authObj : this.#authObj,
            listeners,
            logLevel
        }
        if(!this.#userAgent) this.#userAgent = new UserAgent(config);
        mic();
    }

    isTokenValid() {
        return isTokenValid(this.#authObj.getToken);
    }

    async updateToken() {
        await this.#authObj.registerSoftphone();
    }

    async makeCall(number, virtualNumber) {
        this.#checkIsLoggedIn('Softphone.makeCall')
        if(!number || !number.trim()?.length){
            throw new MissingParameterException('Softphone.makeCall', ['number']);
        }
        if(!number.startsWith('+91') || number.trim().length !== 13){
            throw new InvalidValueException('Softphone.makeCall', 'number', number, ['+91XXXXXXXXXX'])
        }
        if(virtualNumber && (!virtualNumber.startsWith('+91') || virtualNumber.trim().length !== 13)){
            throw new InvalidValueException('Softphone.makeCall', 'virtualNumber', virtualNumber, ['+91XXXXXXXXXX'])
        }
        return await this.#userAgent.makeCall(number, virtualNumber);
    }

    
    #checkIsLoggedIn(source){
        if(this.#isLoggedIn){
            return true;
        }
        else{
            throw new UnauthorizedException(source, `Login to softphone to call ${source}`)
        }
    }

    get getIsLoggedIn(){
        return this.#isLoggedIn;
    }

    get getSession() {
        this.#checkIsLoggedIn();
        return this.#userAgent.getSession
    }

    /**@param {boolean} loggedInState */
    set setIsLoggedIn(loggedInState) {
        this.#isLoggedIn = loggedInState;
    }

    async logout(){
        if(!this.#isLoggedIn){
            console.warn('Already logged out');
            return;
        }
        await this.#userAgent.stop();
        this.#userAgent = null;
        this.#authObj = null;
        this.#isLoggedIn = false;
    }

    async reset(isReconnect=true) {
        this.#checkIsLoggedIn('Softphone.resetSoftphone')
        if(isReconnect) this.#userAgent.reConnect();
        else this.#userAgent.reRegister();
    }
}

export default Softphone;